<template>
  <modal
    :visible.sync="isVisible"
    class="--fit-content"
    height="500px"
  >
    <div class="disassembly-modal">
      <img src="@/assets/img/tools.png" alt="tools icon" class="disassembly-modal__img"/>
      <span class="disassembly-modal__text">
        {{$t('inventory.furnitures.disassemblyQuestion')}}
      </span>
      <div class="disassembly-modal__actions">
        <input-selector v-model="displayCheckBox"
                        class="disassembly-modal__actions__selector"
                        @change="updateFurniture"
                        :options="yesNo"
                        button-class="yes-no-button" />
      </div>
      <div class="disassembly-modal__auto-disassembly" v-if="displayCheckBox">
        <el-checkbox :label="checkboxText"
                     v-model="autoDisassembly"
                     border
        />
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../utils/Modal.vue';
import InputSelector from '@/components/utils/InputSelector.vue';

export default {
  name: 'DisassembleModal',
  components: { Modal, InputSelector },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    yesNo() {
      return [
        {
          label: this.$t('base.yes'),
          value: true,
        },
        {
          label: this.$t('base.no'),
          value: false,
        },
      ];
    },
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
    checkboxText() {
      if (this.isMobile) return this.$t('inventory.furnitures.disassembleAllFurnitureMobile');
      return this.$t('inventory.furnitures.disassembleAllFurniture');
    },
  },
  data() {
    return {
      autoDisassembly: false,
      displayCheckBox: null,
    };
  },
  methods: {
    updateFurniture(value) {
      if (!value) {
        this.autoDisassembly = false;
      }
      this.$emit('update:furniture', value);
    },
  },
  watch: {
    autoDisassembly: {
      handler(value) {
        this.$emit('update:disassembly', value);
      },
      immediate: false,
    },
  },
};
</script>

<style scoped lang="scss">
  .active {
    background-color: rgba(28, 219, 161, 0.1);
    border: 1px solid $--color-primary;
  }

  .disassembly-modal {
    width: 100%;
    max-width: 450px;
    display: grid;
    grid-template-rows: auto auto auto auto;
    place-items: center;
    padding: 1em;
    &__img{
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 1em;
    }
    &__text{
      font-size: 19px;
      line-height: 24px;
      font-weight: bold;
      text-align: center;
      @include breakpoint(mobile){
        font-size: $--font-size-medium;
      }
      @media screen and (max-height: 800px ) {
        font-size: $--font-size-medium;
      }
    }

    &__auto-disassembly{
      width: 100%;
      max-width: 320px;
      padding: 0 10px;

      ::v-deep {
        .el-checkbox {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 30px 20px;
          border-color: $--color-text-primary;

          &.is-checked {
            background-color: rgba(28, 219, 161, 0.1);
            border-color: $--color-primary;
          }

          &__label {
            white-space: normal;
            color: $--color-text-primary !important;
          }
        }
      }
    }
    &__actions{
      display: flex;
      width: 100%;
      justify-content: space-evenly;
      margin: 1em 0;

      &__selector{
        width: 100%;
        max-width: 320px;
      }
    }
  }

  ::v-deep {
    .yes-no-button {
      flex: 1 1 !important;
    }
  }
</style>
